import { PageHero } from "../components/layout/PageHero";

export function StartPage() {
  return (
      <PageHero
        eyebrow="Teste grátis"
      title="Comece com 7 dias grátis."
      text="A ativação self-serve do THH GO Beauty vai começar com plano escolhido, cartão de crédito ou Pix automático na entrada e cobrança apenas depois de 7 dias. Se cancelar antes, nada é cobrado."
      primary={{ href: "/go/checkout", label: "Preparar checkout" }}
      secondary={{ href: "/go/pricing", label: "Ver planos" }}
    />
  );
}
